/**
 * Het blauwe rondje met het nummer van een alinea.
 */
import React from 'react';

export function Nummer({ n, grootte = 24 }) {
  return (
    <span style={{
      minWidth: grootte,
      height: grootte,
      borderRadius: '50%',
      background: 'var(--accent)',
      color: 'var(--wit)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: Math.max(11, Math.round(grootte / 2)),
      fontWeight: 600,
      flexShrink: 0,
    }}>
      {n}
    </span>
  );
}
